import { createApp } from 'vue'
import App from '@/App.vue'
import {createRouter} from '@/router'
import { createApolloProvider } from '@vue/apollo-option'
import ApolloClient from 'apollo-boost'
import VueCookies from 'vue-cookies'
import {errorGeneral} from '@/error.js'

// Encapsulado thodo en un async para que el fetch pueda hacer un await
(async function() {
  // Control de cierre por superflag
  // Lo hago fuera del entorno Vue para asegurarme de que
  // se establece la cookie CSRF antes de cualquier otra petición
  let initParms = {
    cerrado: false,
    registro: false,
  };
  // eslint-disable-next-line no-undef
  if (window.location.pathname !== '/#/aviso') {
      try {
        const resp = await fetch(process.env.VUE_APP_API_URL + '/init/');
        initParms = await resp.json();
        if (initParms.cerrado) {
          // eslint-disable-next-line no-undef
          window.location.replace('/#/aviso');
        }
      } catch (e) {
        console.error(e);
      }
  }

  // eslint-disable-next-line no-undef
  window.onerror = errorGeneral;

  const app = createApp(App, {initParms: initParms});
  app.use(VueCookies);

  app.config.globalProperties.$nombreToken = 'npa-auth-token';
  app.config.globalProperties.$nombreTokenMaestro = 'npa-auth-mtoken';
  app.config.globalProperties.$mensajeClave = `El sistema le ha generado una NUEVA CLAVE que le dará acceso a consultar, 
  SIEMPRE QUE ESTÉ ACTIVO, nuevamente las calificaciones, 
  a reclamar la calificación de alguna asignatura 
  y también a la descarga de la tarjeta de calificaciones.`;

  // Declaro el apollo client después de iniciar la aplicación para poder tener acceso al objeto app
  const apolloClient = new ApolloClient({
    uri: process.env.VUE_APP_API_URL,
    request: async (operation) => {
      // eslint-disable-next-line no-undef
      if (sessionStorage.getItem(app.config.globalProperties.$nombreToken)) {
        operation.setContext({
          headers: {
            // eslint-disable-next-line no-undef
            'Authorization': 'JWT ' + sessionStorage.getItem(app.config.globalProperties.$nombreToken),
            'X-CSRFTOKEN': app.$cookies.get('csrftoken'),
          }
        });
      }
      else {
        operation.setContext({
          headers: {
            'X-CSRFTOKEN': app.$cookies.get('csrftoken'),
          },
        });
      }
    }
  });

  const apolloProvider = createApolloProvider({
    defaultClient: apolloClient,
  });

  app.use(apolloProvider);
  app.use(createRouter(app));
  app.mount('#app');
})();
